import { BaseModel } from '../basemodel';

export class SoftwareLabel extends BaseModel {
  name?: string;

  description?: string;
}
